import { useState } from "react";
import instance from "../Api/Instance";
import { back } from "../Api/ApiUrl";

const initialLabelDetailsState = {
  isLoading: false,
  data: [],
  errors: [],
};

export default function useLabels() {
  const [labelDetails, setLabelDetails] = useState(initialLabelDetailsState);

  const resetLabelsErrors = () => setLabelDetails(initialLabelDetailsState);

  const getErrorMessage = (error) => {
    const serverMessage = error?.response?.data?.moreInformation?.description;

    if (error?.response?.status === 400 && serverMessage) {
      return serverMessage;
    }

    return "Se ha producido un error al generar la etiqueta. Inténtelo de nuevo.";
  };

  const getLabels = async (shipmentCodes, printMode = 1) => {
    setLabelDetails({
      ...initialLabelDetailsState,
      isLoading: true,
    });
    try {
      const response = await instance.get(back.getLabels, {
        params: {
          shipments: shipmentCodes,
          printMode: printMode,
        },
      });

      if (response.status === 200) {
        setLabelDetails({
          isLoading: false,
          data: response?.data,
          errors: [],
        });
        return response?.data;
      }
      setLabelDetails({
        ...initialLabelDetailsState,
        errors: [
          "Se ha producido un error al generar la etiqueta. Inténtelo de nuevo.",
        ],
      });
      return false;
    } catch (error) {
      console.error(error);

      setLabelDetails({
        ...initialLabelDetailsState,
        errors: [getErrorMessage(error)],
      });

      return false;
    }
  };

  return { getLabels, labelDetails, resetLabelsErrors };
}
